import { Button, Flex, Paper, Text } from '@mantine/core'
import withErrorBoundaryAndPolicyCheck from '@v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import PolicyCheckHOC from '@v2/commons/HOC/policyCheckHOC'
import { WbfPolicies } from '@workers-benefit-fund/shared-data'
import { useEffect } from 'react'
import { useState } from 'react'

import { Icons } from 'src/common/components/ui'

import { IMessage } from '../types/chat.types'
import AddMessage from './AddNewMessage/addMessage.component'
import ChatList from './ChatMessageList/chatMessageList.component'
import styles from './chat-component.module.scss'

interface IChatMessagesProps {
  messages?: IMessage[]
  addChatMessageMutationStatus: { isSuccess: boolean; isLoading: boolean }
  isGetMessagesError: boolean
  onAddNote: (content: string) => void
  onUpdateNote: (content: string, chatMessageId: string) => void
  updateChatMessageMutationStatus: { isSuccess: boolean; isLoading: boolean }
  onDeleteNote: (chatMessageId: string) => void
  deleteChatMessageMutationStatus: { isSuccess: boolean; isLoading: boolean }
  hasUpdtaeMessagePolicy: boolean
  hasDeleteMessagePolicy: boolean
  currentUserId: string
}

const ChatMessages = ({
  messages,
  addChatMessageMutationStatus,
  isGetMessagesError,
  onAddNote,
  onUpdateNote,
  updateChatMessageMutationStatus,
  onDeleteNote,
  deleteChatMessageMutationStatus,
  hasUpdtaeMessagePolicy,
  hasDeleteMessagePolicy,
  currentUserId,
}: IChatMessagesProps) => {
  const [editMode, setEditMode] = useState(false)

  useEffect(() => {
    if (addChatMessageMutationStatus.isSuccess) {
      setEditMode(false)
    }
  }, [addChatMessageMutationStatus.isSuccess])

  return (
    <>
      {editMode ? (
        <AddMessage
          onCancel={() => setEditMode(false)}
          onAddNote={onAddNote}
          isLoading={addChatMessageMutationStatus.isLoading}
        />
      ) : (
        <PolicyCheckHOC policyName={WbfPolicies.is_create_chat_message_enabled}>
          <Flex justify={'flex-end'}>
            <Button
              onClick={() => setEditMode(true)}
              variant="filled"
              className={styles['add-note-button']}
              leftSection={<Icons.Plus height={16} width={16} />}
            >
              New Note
            </Button>
          </Flex>
        </PolicyCheckHOC>
      )}
      {isGetMessagesError ? (
        <Paper
          classNames={{
            root: styles['chat-message-list-item'],
          }}
        >
          <Text c="var(--mantine-color-red-6)" fz={16} fw={700}>
            Failed to load messages.
          </Text>
        </Paper>
      ) : (
        <ChatList
          messages={messages ?? []}
          onUpdateNote={onUpdateNote}
          updateChatMessageMutationStatus={updateChatMessageMutationStatus}
          onDeleteNote={onDeleteNote}
          deleteChatMessageMutationStatus={deleteChatMessageMutationStatus}
          hasUpdtaeMessagePolicy={hasUpdtaeMessagePolicy}
          hasDeleteMessagePolicy={hasDeleteMessagePolicy}
          currentUserId={currentUserId}
        />
      )}
    </>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  ChatMessages,
  WbfPolicies.is_get_chat_messages_enabled,
)
